export default __webpack_public_path__ + "static/media/q3_step3.f78b324f.png";